// extracted by mini-css-extract-plugin
export default {"list_of_done":"orders-info_list_of_done__WvOWn","list_of_created":"orders-info_list_of_created__DvRvh"};